<template>
  <auth-template>
    <form @submit.prevent="passwordReset">
      <h2>{{ env }}Reset Password</h2>

      <div class="element">
        <input
          required
          v-model="form.password"
          type="password"
          placeholder="New Password"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          title="Must contain at least one  number and one uppercase and lowercase letter, and at least 8 or more characters"
        />
      </div>

      <div class="element">
        <input
          required
          v-model="form.passwordConfirm"
          type="password"
          placeholder="Confirm New Password"
        />
      </div>

      <b-button type="submit" variant="success">Reset</b-button>

      <hr />

      <div>
        <router-link to="/login" class="password-link"
          >Back to login</router-link
        >
      </div>
    </form>
  </auth-template>
</template>

<script>
import { recaptcha } from "@/components/mixins/recaptcha";
import AuthTemplate from "@/views/Auth/AuthTemplate.vue";

export default {
  name: "PasswordReset",
  components: { AuthTemplate },
  props: ["passRef"],
  mixins: [recaptcha],
  data() {
    return {
      loading: false,
      form: {
        password: "",
        passwordConfirm: ""
      }
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    }
  },
  methods: {
    async passwordReset() {
      const title = "Resetting Password";
      const subtitle = "Please wait a moment";
      await this.$store.dispatch("loaderInitiate", { title, subtitle });

      const token = await this.recaptchaToken();

      const key = this.passRef;
      const password = this.form.password;
      const passwordConfirm = this.form.passwordConfirm;
      this.$store
        .dispatch("passwordReset", { key, password, passwordConfirm, token })
        .then(() => {
          const title = "Password Reset";
          const subtitle = "You can now login to your account";
          this.$store.dispatch("pushSuccess", { title, subtitle });
          this.$router.push("/login");
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: err
          });
        })
        .finally(() => {
          this.$store.dispatch("loaderCancel");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.password-link {
  cursor: pointer;
  font-size: 0.8rem;
}

h2 {
  text-align: center !important;
  font-size: 1.4rem !important;
}

h3 {
  font-size: 1.1rem;
}
</style>
